import { render } from "./ChargebeeUpsellMarketingItem.vue?vue&type=template&id=5ecf98c7"
import script from "./ChargebeeUpsellMarketingItem.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellMarketingItem.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellMarketingItem.vue?vue&type=style&index=0&id=5ecf98c7&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__